import './App.css';

function App() {
  return (
    <main className="App">
      <section>
        <h3>Sorry...</h3>
        <h1 className="no-service">It looks like you are based somewhere we aren't able to service at the moment.</h1>
        <h2>Feel free to send us a text to let us know where you are located so we can work on getting access in your area.</h2>
        <h2 className="number">Our number is 415-418-7418</h2>
        <h1 className="thanks">Thanks for trying Beam!</h1>
      </section>
    </main>
  );
}

export default App;
